import Vue from "vue";
import App from "@/App.vue";
import router from "@/router/router";
import store from "@/store/store";

const js_frame_init = async () => {
  try {
    new Vue({
      router,
      store,
      render: (h: any) => h(App),
      created() {
        //
      },
      mounted() {
        this.$nextTick(() => {
          // DOM Ready!
          return true;
        });
      }
    }).$mount("#app");
  } catch (error) {
    return Promise.reject(error);
  }
};

export default js_frame_init;
